import { useCallback, useContext, useMemo, useState } from "react";
import { GameRuleId, SpearheadArmyId } from "whole-shared";

import { ClientAosFactions } from "../match/aos";
import { ClientSpearheadArmies } from "../match/aos4spearhead";
import { ClientGameRules } from "../match/rules";
import { PopUp, RequestButton } from "./Components";
import { Context } from "./context";

type RulesDetails = { [key in GameRuleId]: { dev: boolean; id: GameRuleId; name: string; visible: boolean } };

const Label = ({ label }: { label: string }) => <span style={{ display: "inline-block", width: 200 }}>{label}:</span>;

const SelectArmy = ({ label, onChange, value }: { label: string; onChange: (value: string) => void; value: string }) => <>
  <Label label={label} />
  <select onChange={event => onChange(event.target.value)} value={value}>
    {SpearheadArmyId.map(id => <option key={id} value={id}>
      {ClientAosFactions[ClientSpearheadArmies[id].faction].name}: {ClientSpearheadArmies[id].name}
    </option>)}
  </select>
  <br />
  <br />
</>;

interface ArmySelectionProps {
  armies: [SpearheadArmyId, SpearheadArmyId];
  devGameRule: boolean;
  onChange: React.Dispatch<React.SetStateAction<[SpearheadArmyId, SpearheadArmyId]>>;
}

const ArmySelection = ({ armies, devGameRule, onChange }: ArmySelectionProps) => {
  const changeArmy0 = useCallback((value: string) => onChange([value as SpearheadArmyId, armies[1]]), [onChange, armies]);
  const changeArmy1 = useCallback((value: string) => onChange([armies[0], value as SpearheadArmyId]), [onChange, armies]);

  return devGameRule ? <>
    <SelectArmy label="Choose Dev1 army" onChange={changeArmy0} value={armies[0]} />
    <SelectArmy label="Choose Dev2 army" onChange={changeArmy1} value={armies[1]} />
  </> : <SelectArmy label="Choose your army" onChange={changeArmy0} value={armies[0]} />;
};

export const QueueSettings = () => {
  const { player, stage, updateContext } = useContext(Context);
  const [armies, setArmies] = useState<[SpearheadArmyId, SpearheadArmyId]>([SpearheadArmyId[0], SpearheadArmyId[0]]);
  const [ruleId, setRuleId] = useState<GameRuleId>("aos4sh");

  const queueSettingsFalse = useCallback(() => updateContext({ queueSettings: false }), [updateContext]);

  const rulesDetails = useMemo(
    () =>
      GameRuleId.reduce<RulesDetails>((ret, id) => {
        const { dev, name } = new ClientGameRules[id](0, 0, ["", ""]);

        return { ...ret, [id]: { dev, id, name, visible: stage !== "prod" && (player.isAdmin() || ! dev) } };
      }, {} as RulesDetails),
    [stage, player]
  );

  const request = useMemo(() => ({ queue: { enterQueue: { armyId: armies[0], devArmyId: armies[1], ruleId } } }), [armies, ruleId]);

  return <PopUp>
    <div className="box panel" style={{ cursor: "auto", display: "flex", height: 300, margin: 130, padding: 30, position: "relative" }}>
      <div style={{ display: "block" }}>
        <Label label="Choose the game mode" />
        <select onChange={event => setRuleId(event.target.value as GameRuleId)} value={ruleId}>
          {Object.values(rulesDetails)
            .filter(({ visible }) => visible)
            .map(({ id, name }) => <option key={id} value={id}>
              {name}
            </option>)}
        </select>
        <br />
        <br />
        <ArmySelection armies={armies} devGameRule={rulesDetails[ruleId].dev} onChange={setArmies} />
      </div>
      <button onClick={queueSettingsFalse} style={{ bottom: 0, margin: 20, position: "absolute" }}>
        {"Cancel"}
      </button>
      <RequestButton
        onResponse={queueSettingsFalse}
        request={request}
        text="Find match"
        style={{ bottom: 0, margin: 20, marginRight: 40, position: "absolute", right: 0 }}
      />
    </div>
  </PopUp>;
};
